// Automatically generated from TW.Saga.Core.Base, Version=1.0.0.0, Culture=neutral, PublicKeyToken=null @30.07.2019 15:08:14
import { Guid, GuidTools } from '@models/guid';
import { BaseObject } from '@models/BaseObject';

export abstract class SectorStatusArgs_abstract extends BaseObject {
  static $t: string = 'SagaBase.Defines.SectorStatusArgs';
  $t: string = 'SagaBase.Defines.SectorStatusArgs';

  public static GetMembers(): string[] {
    return ['SectorId', 'UserId', 'ZoneState', 'IsAvailable'];
  }

  public GetMembers(): string[] {
    return SectorStatusArgs_abstract.GetMembers();
  }

  public _init(): void {
    //// Add "NO-" before "AUTO_INIT_CODE" if don't want to re-generate at each compilation
    ///*<AUTO_INIT_CODE>*/
    ///*</AUTO_INIT_CODE>*/
  }

  // Add "NO-" before "INSTANCE_MEMBERS" if don't want to re-generate at each compilation
  /*<INSTANCE_MEMBERS>*/

  public SectorId: number = 0;
  public UserId: number = 0;
  public ZoneState: any;
  public IsAvailable: boolean = false;

  /*</INSTANCE_MEMBERS>*/

  // Add "NO-" before "AUTO_IMPLEMENTATION" if don't want to re-generate at each compilation
  /*<AUTO_IMPLEMENTATION>*/

  /*</AUTO_IMPLEMENTATION>*/
}
